import type { StatementMemo } from '../../../../utils/statementBlocks';
import { FigureCell } from './FigureCell';
import { LABEL_SPAN_TO_GROSS, STATEMENT_GRID } from './statementGrid';

export function MemoRow({ memo, currency }: { memo: StatementMemo; currency: string }) {
    return (
        <dl>
            <div className={`${STATEMENT_GRID} text-sm italic text-mp-muted`}>
                <dt className={`pl-4 ${LABEL_SPAN_TO_GROSS}`}>{memo.label}</dt>
                <FigureCell column="Gross" value={memo.amount} currency={currency} />
            </div>
        </dl>
    );
}
